import { Link } from "react-router-dom";
import { Lock, LogIn, Rocket, X } from "lucide-react";

export const SignInGateModal = ({ open, onClose, feature, message }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4" data-testid="signin-gate">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-md" onClick={onClose} />
      <div className="relative w-full max-w-md glass rounded-3xl p-7 animate-in-up border border-white/10">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-slate-400 hover:text-white"
          data-testid="signin-gate-close"
          aria-label="Close"
        >
          <X className="w-5 h-5" />
        </button>
        <div className="flex flex-col items-center text-center">
          <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-4"
            style={{ background: "rgba(139,92,246,0.14)", border: "1px solid rgba(139,92,246,0.4)" }}>
            <Lock className="w-7 h-7" style={{ color: "#c4b5fd" }} />
          </div>
          <h2 className="font-display text-xl font-black text-white uppercase tracking-wide">
            Sign In To Unlock
          </h2>
          <p className="text-slate-400 mt-2 text-sm">
            {message || `Create a free account to ${feature || "unlock this feature"} and start earning points on every session.`}
          </p>
          <div className="flex flex-col sm:flex-row gap-3 w-full mt-6">
            <Link to="/register" className="neon-btn flex-1 py-3.5 text-sm" data-testid="signin-gate-register" onClick={onClose}>
              <Rocket className="w-4 h-4" /> Create Account
            </Link>
            <Link to="/login" className="neon-outline-btn flex-1 py-3.5 text-sm" data-testid="signin-gate-login" onClick={onClose}>
              <LogIn className="w-4 h-4" /> Sign In
            </Link>
          </div>
          <p className="text-slate-500 text-xs mt-4">Guests can still book without an account.</p>
        </div>
      </div>
    </div>
  );
};
